import { Layer, Box, Text, Button } from 'grommet';
import useTranslation from 'next-translate/useTranslation';

import React from 'react';
import { customBugsnagLogger } from '@/utils/bugsnag';
import { BlockedCameraIcon } from '../icons';

const BlockedDevices = ({ setShow }) => {
	const { t } = useTranslation('default');
	const handleCloseBlockedDevices = () => {
		customBugsnagLogger.debug('Blocked devices modal dismissed');
		setShow(false);
	};
	return (
		<Layer onEsc={() => setShow(true)} onClickOutside={() => setShow(true)}>
			<Box pad="large">
				<Box flex justify="center" align="center" direction="row" gap="small">
					<BlockedCameraIcon />
					<Text weight="bold" size="medium">
						{t('modals.camera_mic_blocked')}
					</Text>
				</Box>

				<Text margin={{ top: '10px', bottom: '10px' }}>
					{t('modals.camera_mic_blocked_description')}
				</Text>
				<Button
					onClick={handleCloseBlockedDevices}
					size="medium"
					label={t('modals.continue_no_mic')}
					margin={{ top: '20px' }}
				/>
			</Box>
		</Layer>
	);
};

export default BlockedDevices;
